module.exports = __webpack_public_path__ + "static/media/profile-placeholdericon.f4f42017.png";